<div>
  <app-titlebar #titlebar>
  </app-titlebar>
</div>
<mat-tab-group #masterTabGroup class="jk-tab-group" (selectedTabChange)="onMasterTabChange($event)">
  <mat-tab #myChartMap label="熱力圖">
    @for(idNameItem of filterOpt.stkme001;track idNameItem){
      <app-jkheatmap #heatmap [type]="filterOpt.chartType" [label]="idNameItem.name" [item]="idNameItem.id" [date]="filterOpt.date">
      </app-jkheatmap>
    }
  </mat-tab>
  <mat-tab #myTabGrid label="條件設定">
    <mat-toolbar class="h-9">
      <button class="btn" [class.btn-primary]="true" (click)="doQuery()">
        <mat-icon fontIcon="search"></mat-icon>查詢
      </button>
      <button class="btn" [class.btn-info]="true" (click)="doGetPreFilter()">
        <mat-icon fontIcon="search"></mat-icon>取前次
      </button>
    </mat-toolbar>
    <app-jkcombobox #dataFrom label="資料來源" [(value)]="filterOpt.dataFrom" [items]="dataFromList">
    </app-jkcombobox>
    <div class="jk-cols-4">
      <app-jkdatefield #stklg001Com label="日期" [(value)]="filterOpt.date" [showClearButton]="true" [required]="true">
      </app-jkdatefield>
      <app-jkmultiselect #stkme001Com label="群組" [showClearButton]="true" [required]="true"
      maintable="STKME" item="W80" valueExpr="ME001" displayExpr="ME002"
      [(values)]="filterOpt.stkme001">
    </app-jkmultiselect>

      <app-jkcombobox #charttype label="熱力圖/樹狀圖" [(value)]="filterOpt.chartType" [items]="chartTypeList">
      </app-jkcombobox>
    </div>
  <!--     <app-jkdatefield #stklg001Com label="日期" [(value)]="filterOpt.date" [showClearButton]="true" [required]="true">
    </app-jkdatefield>
    <app-jkmultiselect #stkme001Com label="群組" [showClearButton]="true" [required]="true"
    maintable="STKME" item="W01" valueExpr="ME001" displayExpr="ME002"
    [(values)]="filterOpt.stkme001">
  </app-jkmultiselect>

    <app-jkcombobox #charttype label="熱力圖/樹狀圖" [(value)]="filterOpt.chartType" [items]="chartTypeList">

    </app-jkcombobox>
 -->  </mat-tab>
  <mat-tab #myTabDetail label="詳細資料">
    <!-- <app-jkheatmap #heatmap [type]="filterOpt.chartType" [groupList]="idNameItem2String(filterOpt.stkme001)" [date]="filterOpt.date">
    </app-jkheatmap> -->
    <app-jkgridwin #jkgridwin
      (afterGridReady)="afterGridReady($event)" (rowClicked)="agRowClicked($event)">
    </app-jkgridwin>
  </mat-tab>
</mat-tab-group>

